export default __webpack_public_path__ + "media/images/icons/gear-79c01e86493da17e1b25d118f84636fa.svg";